function fetchJSON(endpoint: string, method: string) {
  const tokenEl = document.querySelectorAll('meta[name=csrf-token]')[0]
  const token = tokenEl.getAttribute('content')

  return fetch(`${endpoint}?_=${new Date().getTime()}`, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token,
    },
    method,
  }).then((response) => {
    try {
      if (response.status >= 400) {
        throw new Error(response.statusText)
      }

      return response.json()
    } catch (error) {
      return Promise.reject(error)
    }
  })
}

export { fetchJSON }
